import { isAxiosError } from 'axios'

import { MAX_UPLOAD_SIZE } from './upload'

type UploadErrorResponse = Partial<{
  errors: Partial<{ file: string | string[] }>
}>

const MEGABYTE = 1024 * 1024

export const getTooLargeMessage = () =>
  `This file is too large to upload. The maximum size is ${MAX_UPLOAD_SIZE / MEGABYTE} MB.`

export const getUploadErrorMessage = (error: unknown): string => {
  if (isAxiosError<UploadErrorResponse>(error)) {
    const status = error.response?.status

    if (status === 401) {
      return 'Sign in to upload files, then try again.'
    }

    if (status === 403) {
      return 'You do not have permission to upload files to this project.'
    }

    if (status === 413) {
      return 'This file is too large to upload. Choose a smaller file and try again.'
    }

    const fileError = error.response?.data?.errors?.file
    const message = Array.isArray(fileError) ? fileError.join(' ') : fileError

    if (message) {
      return message
    }

    if (!error.response) {
      return 'Upload failed. Check your connection and try again.'
    }
  }

  return 'The file could not be uploaded. Please try again.'
}
